export const pageIsOutOfRange = (currentPage: number, endIndex: number, itemsPerPage: number) => {
  return currentPage >= Math.ceil(endIndex / itemsPerPage) && currentPage >= 0;
};
